import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { ClassificacaoNivelTipoClassificacaoFilterPipe } from './classificacao-nivel-tipo-classificacao-filter.pipe';
import { ClassificacaoAgrupamentoNivelTipoClassificacaoFilterPipe } from './classificacao-agrupamento-nivel-tipo-classificacao-filter.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClassificacaoNivelTipoClassificacaoFilterPipe,
        ClassificacaoAgrupamentoNivelTipoClassificacaoFilterPipe
    ],
    exports: [
        ClassificacaoNivelTipoClassificacaoFilterPipe,
        ClassificacaoAgrupamentoNivelTipoClassificacaoFilterPipe
    ],
    providers: [
        ClassificacaoNivelTipoClassificacaoFilterPipe,
        ClassificacaoAgrupamentoNivelTipoClassificacaoFilterPipe
    ]
})
export class ClassificacaoPipeModule { }
